import { render } from "./MultipleSelectDropdown.vue?vue&type=template&id=e3ef97ee"
import script from "./MultipleSelectDropdown.vue?vue&type=script&lang=ts"
export * from "./MultipleSelectDropdown.vue?vue&type=script&lang=ts"
script.render = render

export default script